const LogoSVG = ({ className = "", theme = "light" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    /* Tight square box: the roof corner (y=12.8) lands at exactly 50% height,
       so with align-items:center the "H" crossbar of the wordmark lines up with
       it. Keep in sync with public/LogoSVG_tb_bt.svg. */
    viewBox="3.16 3.96 17.68 17.68"
    width="17.68"
    height="17.68"
    fill="none"
    className={`inline-block align-middle ${className}`}
    aria-hidden="true"
    focusable="false"
  >
    {/* House */}
     <g
      stroke="currentColor"
      strokeWidth={1.68}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M4.8 20 L4.8 12.2" />
      <path d="M19.2 12.2 L19.2 20" />
      <path d="M4.8 20 L12 20" />
      <path d="M12 5.6 L4 12.8" />
      <path d="M12 5.6 L20 12.8" />
    </g>

    {/* AI text—with explicit fill */}
    <text
      x="12"
      y="18.4"
      textAnchor="middle"
      fontFamily="Arial, sans-serif"
      fontWeight="bold"
      fontSize="9.6"
      fill={theme === 'dark' ? '#fff' : '#000'}
    >
      AI
    </text>
  </svg>
);


export default LogoSVG;